import { render, staticRenderFns } from "./Codir.vue?vue&type=template&id=4158ac3c"
import script from "./Codir.vue?vue&type=script&lang=js"
export * from "./Codir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports